/**
 * Surface language shared by the workspace pickers, mirroring the modal
 * treatment. Applied to each picker's own container; the container keeps its
 * padding/background/width.
 */
export const WORKSPACE_PICKER_SURFACE = 'rounded-[10px] border border-border shadow-modal';
